/* eslint-disable */
import 'jquery';
import Cookie from 'js-cookie';
import {vfNetWorkCheck} from '../../v3/src/11_functions/_qaProdEndpoints'
import '../scss/validation.scss';
import '../scss/device-compatibility-check.scss';
import gaTracker from './ga-tracker';

import getUrlParameter from './get-url-parameter';
import updateUrlParameter from './update-url-parameter';
import isPage from './is-page';

import React from 'react';
import ReactDOM from 'react-dom';
import { datadogLogs } from "@datadog/browser-logs";
datadogLogs.logger.info("The v2 theme file ran: /src/js/validation.js", {type: 'file accessed', filename: "/src/js/validation.js"});

// import DeviceCompatibilityCheck from './device-compatibility-check';
class DeviceCompatibilityCheck {
	render() {
		return <div></div>
	}
}

var zipApi = vfNetWorkCheck(),
	zipApiv2 = 'https://api.ultra.me/partner.php?format=json&partner=api_public&command=ultrainfo__ZIPCoverageInfo&bath=rest&version=1&zipcode=',
	deviceApi = 'https://compatibility-api.mintsim.com/v1/device?modelName=',
	$zipForm = $('.js-valid-zip-form'),
	$pageTitle = $('.js-valid-title'),
	$zipCodeField = $('.js-valid-zip-code'),
	$coverageTab = $('.js-valid-coverage'),
	$coverageAction = $('#js-coverage-to-compatibility'),
	$deviceTab = $('.js-valid-device'),
	$plansTab = $('.js-valid-plans'),
	$zipDisplay = $('.js-show-zip-code'),
	$resultUncertain = $('.js-results-uncertain'),
	$resultSolid = $('.js-results-solid'),
	$resultCovered = $('.js-results-covered'),
	$meter4glte = $('.js-meter-4glte'),
	$meter4g = $('.js-meter-4g'),
	$meter3g = $('.js-meter-3g'),
	$meter2g = $('.js-meter-2g'),
	$meterNotComp = $('.js-meter-not-comp'),
	$deviceNotCompatible = $('.js-compat-false'),
	$device4glte = $('.js-compat-4glte'),
	$device4g = $('.js-compat-4g'),
	$device3g = $('.js-compat-3g'),
	$device2g = $('.js-compat-2g'),
	$deviceName = $('.js-results-device-name'),
	$deviceForm = $('.js-valid-device-form'),
	$devicefull = "Phone",
	params = {
		coverage: (getUrlParameter('coverage')) ? getUrlParameter('coverage') : window.localStorage.getItem('coverage'),
		compatibility: (getUrlParameter('compatibility')) ? getUrlParameter('compatibility') : window.localStorage.getItem('compatibility'),
		zip: (getUrlParameter('zip')) ? getUrlParameter('zip') : window.localStorage.getItem('zip'),
		device: (getUrlParameter('device')) ? getUrlParameter('device') : window.localStorage.getItem('device')
	};
	

if (params.zip && isPage('coverage-results')) {
	var coverageUrl = zipApi + params.zip;
	$.getJSON(coverageUrl, function(result){
		//response data are now in the result variable
		handleZipSuccess(result);
	 });	
	
		
} else {
	setPageState(params);
	storeValues(params);
}


function renderDeviceCompatibilityCheck(deviceList) {
	let reactComponent;
	reactComponent = <DeviceCompatibilityCheck devices={ deviceList } />;

	ReactDOM.render(
		reactComponent,
		document.getElementById('js-device-dropdown')
	);
}
// If the dom node is there make the api call
if (document.getElementById('js-device-dropdown')) {
	$.ajax({
		url: (data_source.length > 0) ? data_source : window.location.origin + '/api/mint-device-list-final.json',
		success: function (response) {
			renderDeviceCompatibilityCheck(response);
		}
	});
}
	
function setPageState(state) {
	
	var coverage = state.coverage * 1, // simple conversion to a number
		compatibility = state.compatibility,
		zip = state.zip,
		device = state.device,
		page = window.location.pathname;
		
	if (zip === null && coverage === 0 && isPage('coverage-results')) {
		window.location.href = window.location.origin + '/check-coverage/';
	}
	
	if (compatibility == null && isPage('compatibility-results')) {
		window.location.href = window.location.origin + '/device-compatibility/';
	}
		
	if (coverage < 3) {
		$resultUncertain.show();
		$resultSolid.hide();
		$resultCovered.hide();
		
	} else {
		
		$resultUncertain.hide();
		
		if ($coverageTab.hasClass('active')) {
			$coverageTab.find('.check-active').show();
		} else {
			$coverageTab.find('.check').show();
		}
		
		$coverageTab.addClass('success');
		$coverageTab.attr('href', '/coverage-results/');
		
		if (coverage >= 3 && coverage <= 6) {
			$resultSolid.show();
		} else {
			$resultCovered.show();
		}
	}
	
	if (isPage('coverage-results') && zip && coverage) {
		gaTracker.track('zip|Validation Flow|Coverage Results|' + zip + '|coverage result|' + coverage);
	}
	
	if (isPage('compatibility-results') && compatibility && device) {
		gaTracker.track('device|Validation Flow|Device Results|' + device + '|device result|' + compatibility);
	}
	
	if (zip) {
		$zipDisplay.html(zip);
	}
	
	if (compatibility && (compatibility == '4GLTE' || compatibility == '4G' || compatibility == '3G' || compatibility == '2G')) {

		
		if ($deviceTab.hasClass('active')) {
			$deviceTab.find('.check-active').show();
		} else {
			$deviceTab.find('.check').show();
		}


		$coverageAction.attr('href', '/compatibility-results');
		
		$deviceTab.addClass('success');
		$deviceTab.attr('href', '/compatibility-results/');
		$deviceName.html(params.device);
		
		switch(compatibility) {
			case '4GLTE':
				$device4glte
					.add($meter4glte)
					.show();
				break;
			case '4G':
				$device4g
					.add($meter4g)
					.show();
				break;
			case '3G':
				$device3g
					.add($meter3g)
					.show();
				break;
			case '2G':
				$device2g
					.add($meter2g)
					.show();
				break;
			default: break;
		}
		
	} else {
		$deviceNotCompatible.add($meterNotComp).show();
	}
	
}

function storeValues(data) {
	for (var key in data) {
		if (data.hasOwnProperty(key) && data[key]) {
			window.localStorage.setItem(key, data[key]);
		}
	}
}

function getSelectedDevice() {
	const deviceName = $('[name=deviceModelSelect]').val();
	return deviceName;
}

// Check zip coverage on form submit
$zipForm.on('submit', function(event) {
	event.preventDefault();
	var zipCode = $zipCodeField.val();
	if (zipCode){
		var pageTitle = $pageTitle.text(),
		coverageUrl = zipApi;
		let data = {
			address: {
			  zip: zipCode
			}
		};
		checkZipCode = $.ajax({
			type: 'post',
			url: coverageUrl,
			data: data,
			dataType: 'json'
		});	
	}
		
	if (!zipCode) {
		return false;
	}
	checkZipCode
	.done(function(response) {
		return handleZipSuccess(response, zipCode)
	})
	gaTracker.track('zip|Validation Flow|Check Coverage|' + zipCode + '|entry header|' + pageTitle);
});

// A/B testability for whether or not to get something....
// We could honestly probably move this whole form into react 

$deviceForm.on('submit', function(event) {
	event.preventDefault();
	const DEVICE_COMPATIBILITY_CHECK_TWO_STEP = 'deviceCompatibilityCheckTwoStep';
	const deviceCompatibilityCheckTwoStep = Cookie.get(DEVICE_COMPATIBILITY_CHECK_TWO_STEP); 
	var deviceBrand = (deviceCompatibilityCheckTwoStep > 0) ? getSelectedDevice() : $('[name=brandName]').val();
	var deviceName = (deviceCompatibilityCheckTwoStep > 0) ? getSelectedDevice() : $('[name=deviceModelSelect]').val();;

	var checkDevice = $.ajax({
			type: 'get',
			url: deviceApi + encodeURI(deviceName)
		});
	checkDevice
		.done(handleDeviceSuccess)
		.fail(handleCallFailure);	
	gaTracker.track('device|Validation Flow|Check Device|' + deviceName);
});

function handleZipSuccess(response) {

	if (isPage('check-coverage')) {
		var url = updateUrlParameter(window.location.origin + '/coverage-results/', 'zip', $zipCodeField.val());
		window.location.href = updateUrlParameter(url, 'coverage', response.quality);
	}
	
	if (isPage('coverage-results')) {
		params.coverage = response.quality;
		params.zip = params.zip;
		storeValues(params);
		setPageState(params);
	}

}

function handleDeviceSuccess(response) {

	if (response[0] == null || !isPage('device-compatibility')) {
		return;
	}
	var speedList = [];
	var speeds = response.map(function(obj) {
			if (obj.compatibility['2G'] && speedList.indexOf('2G') === -1) { speedList.push('2G'); }
			if (obj.compatibility['3G'] && speedList.indexOf('3G') === -1) { speedList.push('3G'); }
			if (obj.compatibility['4G'] && speedList.indexOf('4G') === -1) { speedList.push('4G'); }
			if (obj.compatibility['LTE'] && speedList.indexOf('4GLTE') === -1) { speedList.push('4GLTE'); }
			if (speedList.length == 0 && speedList.indexOf('not-compatible') === -1) { speedList.push('not-compatible'); }
		});

	if (speedList.includes("not-compatible") && speedList.length > 1) {
		var indexRemove = speedList.indexOf("not-compatible");
		speedList.splice(indexRemove, 1);
	};

	
	var speedList = speedList.sort();
	var compatibility = speedList.pop();
	var url = updateUrlParameter(window.location.origin + '/compatibility-results/', 'compatibility', compatibility);

	const DEVICE_COMPATIBILITY_CHECK_TWO_STEP = 'deviceCompatibilityCheckTwoStep';
	const deviceCompatibilityCheckTwoStep = Cookie.get(DEVICE_COMPATIBILITY_CHECK_TWO_STEP); 
	var deviceBrand = (deviceCompatibilityCheckTwoStep > 0) ? getSelectedDevice() : $('[name=brandName]').val();
	var deviceName = (deviceCompatibilityCheckTwoStep > 0) ? getSelectedDevice() : $('[name=deviceModelSelect]').val();
	window.location.href = updateUrlParameter(url, 'device', deviceBrand + "_" + deviceName);
}


if (isPage('compatibility-results')) {
	var sd = window.localStorage.getItem('device');
	var urldevice = getUrlParameter('device');
	var stored_device = (urldevice) ? urldevice.replace("_"," ") : sd.replace("_", " ");
	$('.phone').text(stored_device);

}

